import { Typography } from '@mui/material';
import { SectionTitle } from 'components/FiltersModal/components';
import styled from 'styled-components';
import fonts from 'styles/fonts';
import media from 'styles/media';
import sizes from 'styles/sizes';
import transition from 'styles/transition';

export const Constrain = styled.div`
  min-height: 390px;
  width: 100%;
  position: relative;

  ${media.small`
    flex-direction: column;
    align-items: center;
  `}
`;

export const MonthWrapper = styled.div`
  position: absolute;
  width: 33.3333%;
  left: calc(${props => props.index} * 33.3333%);
  opacity: 0;
  padding: 0;

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    padding: 0 20px;
  }

  ${media.medium`
    width: 50%;
    left: calc(${props => props.index} * 50%);

  `}

  ${media.small`
    max-width: 414px;
    position: relative;
    margin-right: unset;
    width: 100%;
    left: unset;
    margin: 0 auto;
  `}
`;

export const MonthLabel = styled(SectionTitle)`
  &.monthLabel {
    text-transform: capitalize;
    width: 100%;
    text-align: center;
  }
`;

export const PickerWrapper = styled.div`
  display: flex;
  flex-grow: 1;

  ${media.small`
    margin-bottom: 40px;
  `}
`;

export const DayOfWeekLabel = styled(Typography)`
  text-align: center;
  text-transform: uppercase;
  color: ${({ palette, dayOfWeekUi }) =>
    palette[dayOfWeekUi.color][dayOfWeekUi.shade]};
  flex-grow: 1;
`;

export const DaysOfWeekWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  pointer-events: none;
  margin-bottom: 10px;
`;

export const PickerRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  height: 100%;

  &:first-child button.selected {
    border-radius: ${({ dayButtonUi }) =>
      `${dayButtonUi.borderRadius} 0 0 ${dayButtonUi.borderRadius}`};
  }
  &:last-child button.selected {
    border-radius: ${({ dayButtonUi }) =>
      `0 ${dayButtonUi.borderRadius} ${dayButtonUi.borderRadius} 0`};
  }
`;

export const DayLabel = styled(Typography)`
  align-items: center;
  color: ${({ palette, dayLabelUi }) =>
    palette[dayLabelUi.color][dayLabelUi.shade]};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 101%;
`;

export const DayButton = styled.button`
  width: 100%;
  padding-bottom: 50%; /* Maintains square height as width changes with screen size */

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  margin-bottom: 4px;

  ${DayLabel} {
    transition: background-color 0.1s ${transition.ease.css.default},
      border-radius 0.1s ${transition.ease.css.default};
    height: ${({ dayButtonUi }) => dayButtonUi.height};
  }

  &.first {
    ${DayLabel} {
      color: ${({ palette }) => palette.primary.contrastText};
      border-radius: 30px 0px 0px 30px;
      background-color: ${({ palette }) => palette.primary.dark};
      transition: background-color 0.3s ${transition.ease.css.default},
        color 0.2s 0.1s ${transition.ease.css.default};
    }
  }

  &.last {
    ${DayLabel} {
      color: ${({ palette }) => palette.primary.contrastText};
      border-radius: 0px 30px 30px 0px;
      background-color: ${({ palette }) => palette.primary.dark};
      transition: background-color 0.3s ${transition.ease.css.default},
        color 0.2s 0.1s ${transition.ease.css.default};
    }
  }

  &.selected {
    ${DayLabel} {
      color: ${({ palette, dayButtonUi }) =>
        palette[dayButtonUi.color][dayButtonUi.shade]};
      background-color: ${({ palette, dayButtonUi }) =>
        palette[dayButtonUi.backgroundColor][dayButtonUi.backgroundShade]};
      transition: background-color 0.2s ${transition.ease.css.default};

      border-radius: ${props =>
        props.isLastDay &&
        `0px ${props.dayButtonUi.borderRadius} ${props.dayButtonUi.borderRadius} 0px`};
      border-radius: ${props =>
        props.isFirstDay &&
        `${props.dayButtonUi.borderRadius} 0px 0px ${props.dayButtonUi.borderRadius}`};
      border-radius: ${props =>
        (props.isFirstDay || props.isLastDay) &&
        (props.isSaturday || props.isSunday) &&
        `${props.dayButtonUi.borderRadius} !important`};

      border: solid 1px
        ${({ palette, dayButtonUi }) =>
          palette[dayButtonUi.backgroundColor][dayButtonUi.backgroundShade]};
    }
  }

  &.disabled {
    pointer-events: none;
  }

  &.disabled-facet {
    opacity: 0.3;
    pointer-events: none;
  }

  &.unavailable {
    opacity: 0.3;
    pointer-events: none;
  }
`;

/* Maintains square height for DayButton as width changes with screen size */
export const HeightHiddenSpan = styled.span`
  color: transparent;
  font-family: ${fonts.primary.regular};
  font-size: 16px;
  line-height: 16px;
  visibility: hidden;
`;
